import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderModule } from '../shared/header/header.module';
import { SchoolsComponent } from './schools.component';
import { CollapsibleCardModule } from 'src/app/shared/components/collapsible-card/collapsible-card.module';
import { MaterialModule } from 'src/app/shared/material.module';
import { RouterModule } from '@angular/router';
import { LoaderModule } from 'src/app/shared/components/loader/loader.module';
import { ReactiveFormsModule } from '@angular/forms';
import { NgxMaskModule } from 'ngx-mask';
import { DividerModule } from 'src/app/shared/components/divider';
import { SharedPipesModule } from 'src/app/shared/pipes';
import { MessageModule } from 'src/app/shared/message/message.module';
import { SchoolCardModule } from './school-card/school-card.module';
import { SchoolsRoutingModule } from './schools-routing.module';
import { StateCountryEventService } from 'src/app/core/services/state-country-event.service';

@NgModule({
  declarations: [SchoolsComponent],
  imports: [
    CommonModule,
    HeaderModule,
    CollapsibleCardModule,
    MaterialModule,
    RouterModule,
    LoaderModule,
    DividerModule,
    SharedPipesModule,
    ReactiveFormsModule,
    NgxMaskModule,
    MessageModule,
    SchoolCardModule,
    SchoolsRoutingModule
  ],
  providers: [StateCountryEventService],
  exports: [SchoolsComponent]
})
export class SchoolsModule {}
